import React from 'react';
import styled from 'styled-components';
import { Avatar } from './Avatar';
import { Label } from './Label';

export default ({ profileImage, name, twitterName, position, company, ...other }) => (
  <ProfileCardHeader {...other}>
    <ProfileAvatar src={profileImage} />
    <div>
      <PrimaryLine>
        <ProfileName>{name}</ProfileName>
        <Label>{twitterName}</Label>
      </PrimaryLine>
      <SecondaryLine>{`${position} @ ${company}`}</SecondaryLine>
    </div>
  </ProfileCardHeader>
);

const ProfileName = styled.span`
  margin-right: 8px;
`;

const ProfileAvatar = styled(Avatar)`
  margin-right: 16px;
`;

const ProfileCardHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
`;

const PrimaryLine = styled.div`
  font-weight: bold;
  font-size: 16px;
`;
const SecondaryLine = styled.div`
  color: #475059;
`;
